import { BASE_POKER_STR, ICON_IMAGE_FORMAT, THE_RAIL_CDN_BASE_URL } from './game';
import { RPGTypes } from './types';

export type NarrowRPGTypes = Exclude<RPGTypes, RPGTypes.PPP | RPGTypes.SAG>;

const IconMap: Record<NarrowRPGTypes, string> = {
  [RPGTypes.MTT]: 'tournaments',
  [RPGTypes.CASH_GAME]: 'cash_games',
  [RPGTypes.SNG]: 'sitandgo'
};

export default function iconFormatter(type: NarrowRPGTypes) {
  return `${THE_RAIL_CDN_BASE_URL}${BASE_POKER_STR}icon_${IconMap[type]}@2x${ICON_IMAGE_FORMAT}`;
}
